/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Formik } from "formik";
import { useState } from "react";
import dayjs from "dayjs";
import * as Sentry from "@sentry/react";
import Styles from "./styles";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { examinationLevel, moduleName, structureLevel } from "../helper";
import InputField from "../../../components/common/new/InputField/InputField";
import {
  APPOINTMENT_CYCLE_FIELDS,
  EXAMINATION_CYCLE_FIELD,
} from "../../../contants/formFields";
import Button from "../../../components/common/Button";
import { debounce } from "../../../utils/helper";
import Announcement from "../../../services/api/announcement";
import AppointMentBoolInput from "../../../components/AppointMentBoolInput/AppointMentBoolInput";
import Modal from "../../../components/common/Modal/Modal";
import Typography from "../../../components/common/new/Typography/Typography";
import { AlertStatus } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";

const isDateValid = (startDate, endDate) =>
  startDate && endDate && new Date(startDate) < new Date(endDate);

export const checkFormValues = (values) => {
  if (!values[APPOINTMENT_CYCLE_FIELDS.ACTIVE])
    return "Please select the Active field";
  if (!values[APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL])
    return "Please select Structure level";
  if (!values[APPOINTMENT_CYCLE_FIELDS.MODULE]) return "Please select Module";
  if (
    !isDateValid(
      values[APPOINTMENT_CYCLE_FIELDS.START_DATE],
      values[APPOINTMENT_CYCLE_FIELDS.END_DATE]
    )
  )
    return "Please enter valid dates.";
  return "";
};

function CreateAnnouncementCycle({ open, onClose, refresh }) {
  const [isLoading, setIsLoading] = useState(false);
  const [minEndDate, setMinEndDate] = useState(null);
  const toast = React.useContext(ToastAlertContext);
  const [defaultValue, setDefaultValue] = useState("APPOINTMENT");

  const getTitle = () => {
    return "Create Announcement Cycle";
  };

  const newcheckFormValues = (values) => {
    if (!values[APPOINTMENT_CYCLE_FIELDS.ACTIVE])
      return "Please select the Active field";
    if (
      values[APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL] === "APPOINTMENT" &&
      !values[APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL]
    )
      return "Please select Structure level";
    if (!values[APPOINTMENT_CYCLE_FIELDS.MODULE]) return "Please select Module";
    if (
      !isDateValid(
        values[APPOINTMENT_CYCLE_FIELDS.START_DATE],
        values[APPOINTMENT_CYCLE_FIELDS.END_DATE]
      )
    )
      return "Please enter valid dates.";
    return "";
  };

  const postData = async (values) => {
    try {
      setIsLoading(true);
      const response = await Announcement.initiateAnnouncementCycle({
        ...values,
        active: values.active === "YES",
      });
      setTimeout(() => {
        onClose();
        refresh();
      }, 2000);
      if (response) {
        toast.show(
          "Announcement cycle created successfully",
          AlertStatus.SUCCESS
        );
      }
      setIsLoading(false);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Grid container>
        <Formik
          initialValues={{
            [APPOINTMENT_CYCLE_FIELDS.START_DATE]: null,
            [APPOINTMENT_CYCLE_FIELDS.END_DATE]: null,
            [APPOINTMENT_CYCLE_FIELDS.MODULE]: "APPOINTMENT",
          }}
          onSubmit={debounce((values) => {
            const error = newcheckFormValues(values);
            if (error) {
              toast.show(error, AlertStatus.ERROR);
              return;
            }
            postData(values);
          })}
        >
          {({ values, setFieldValue, handleSubmit, handleChange }) => (
            <>
              <div style={{ padding: "0px 0px 20px 0px", color: "#8C8C8C" }}>
                <Typography fontWeight="500" fontSize="20px">
                  {getTitle()}
                </Typography>
              </div>
              <div
                style={{
                  paddingRight: "66%",
                  paddingBottom: "12px",
                }}
              >
                <AppointMentBoolInput
                  name={APPOINTMENT_CYCLE_FIELDS.ACTIVE}
                  value={values[APPOINTMENT_CYCLE_FIELDS.ACTIVE]}
                  preLabel="Active"
                  handleChange={handleChange}
                  required
                />
              </div>
              <div style={{ ...Styles.gridContainer }}>
                <div style={Styles.gridItem}>
                  <AutoCompleteDropdown
                    getOptionLabel={(option) => option.displayName}
                    name={APPOINTMENT_CYCLE_FIELDS.MODULE}
                    label="Module Type"
                    options={moduleName}
                    value={values?.[APPOINTMENT_CYCLE_FIELDS.MODULE]}
                    onChange={(selectedValue) => {
                      if (!selectedValue) {
                        setFieldValue(APPOINTMENT_CYCLE_FIELDS.MODULE, "");
                      } else {
                        setFieldValue(
                          APPOINTMENT_CYCLE_FIELDS.MODULE,
                          selectedValue.value
                        );
                        setDefaultValue(selectedValue.value);
                      }
                    }}
                    style={{ fontSize: "14px" }}
                    inputProps={{
                      required: true,
                      placeholder: "Select Module Type",
                    }}
                  />
                </div>
                <div style={Styles.gridItem}>
                  {defaultValue === "APPOINTMENT" ? (
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.displayName}
                      name={APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL}
                      label="Structure Level"
                      options={structureLevel}
                      value={values?.[APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL]}
                      onChange={(selectedValue) => {
                        if (selectedValue) {
                          setFieldValue(
                            APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL,
                            selectedValue.value
                          );
                        }
                      }}
                      style={{ fontSize: "14px" }}
                      inputProps={{
                        required: defaultValue === "APPOINTMENT",
                        placeholder: "Select Structure Level",
                      }}
                    />
                  ) : (
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.displayName}
                      name={EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL}
                      label="Examination Level"
                      options={examinationLevel}
                      value={
                        values?.[EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL]
                      }
                      onChange={(selectedValue) => {
                        if (selectedValue) {
                          setFieldValue(
                            EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL,
                            selectedValue.value
                          );
                        }
                      }}
                      style={{ fontSize: "14px" }}
                      inputProps={{
                        required: defaultValue === "APPOINTMENT",
                        placeholder: "Select Examination Level",
                      }}
                    />
                  )}
                </div>
                <div style={Styles.gridItem}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name={APPOINTMENT_CYCLE_FIELDS.START_DATE}
                      label="Start Date"
                      inputFormat="DD/MM/YYYY"
                      minDate={new Date()}
                      value={values?.[APPOINTMENT_CYCLE_FIELDS.START_DATE]}
                      onChange={(newValues) => {
                        setFieldValue(
                          [APPOINTMENT_CYCLE_FIELDS.START_DATE],
                          dayjs(newValues).format("YYYY-MM-DD")
                        );
                        setMinEndDate(
                          new Date(
                            new Date(newValues).getTime() + 24 * 60 * 60 * 1000
                          )
                        );
                      }}
                      PopperProps={{
                        placement: "right",
                      }}
                      renderInput={(params) => <InputField {...params} />}
                    />
                  </LocalizationProvider>
                </div>
                <div style={Styles.gridItem}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name={APPOINTMENT_CYCLE_FIELDS.END_DATE}
                      label="End Date"
                      inputFormat="DD/MM/YYYY"
                      minDate={minEndDate}
                      value={values?.[APPOINTMENT_CYCLE_FIELDS.END_DATE]}
                      onChange={(newValues) =>
                        setFieldValue(
                          [APPOINTMENT_CYCLE_FIELDS.END_DATE],
                          dayjs(newValues).format("YYYY-MM-DD")
                        )
                      }
                      PopperProps={{
                        placement: "right",
                      }}
                      renderInput={(params) => <InputField {...params} />}
                    />
                  </LocalizationProvider>
                </div>
                {values?.[APPOINTMENT_CYCLE_FIELDS.MODULE] ===
                  "EXAMINATION" && (
                  <div style={Styles.gridItem}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name={EXAMINATION_CYCLE_FIELD.EXAM_DATE}
                        label="Exam Date"
                        inputFormat="DD/MM/YYYY"
                        // minDate={minEndDate}
                        value={values?.[EXAMINATION_CYCLE_FIELD.EXAM_DATE]}
                        onChange={(newValues) =>
                          setFieldValue(
                            [EXAMINATION_CYCLE_FIELD.EXAM_DATE],
                            dayjs(newValues).format("YYYY-MM-DD")
                          )
                        }
                        PopperProps={{
                          placement: "right",
                        }}
                        renderInput={(params) => <InputField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                )}
              </div>
              <div style={Styles.action}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  isLoading={isLoading}
                  label="Submit"
                  type="submit"
                />
                <Button
                  variant="outlined"
                  onClick={onClose}
                  isLoading={isLoading}
                  label="Cancel"
                />
              </div>
            </>
          )}
        </Formik>
      </Grid>
    </Modal>
  );
}

export default CreateAnnouncementCycle;
